import { Box, Chip, Divider, Typography } from '@mui/material';
import moment from 'moment';
import { CommonDialog, CommonDialogHeader } from '..';
import { IRoleContent } from '../../../types/store';

interface Props {
  role: IRoleContent | null;
  isOpen: boolean;
  onClose: () => void;
}

export const ViewRoleDialog = ({ role, isOpen, onClose }: Props) => {
  if (!role) return null;

  const rows = [
    { label: 'ID', value: String(role.id) },
    { label: 'Name', value: role.name },
    { label: 'Description', value: role.description ?? '—' },
    {
      label: 'Created At',
      value: role.created_at ? moment(role.created_at).format('MMMM Do YYYY, h:mm:ss a') : '—',
    },
    {
      label: 'Updated At',
      value: role.updated_at ? moment(role.updated_at).format('MMMM Do YYYY, h:mm:ss a') : '—',
    },
  ];

  return (
    <CommonDialog
      isOpen={isOpen}
      header={<CommonDialogHeader title={role.name} onClose={onClose} />}
      body={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {rows.map(({ label, value }) => (
            <Box key={label}>
              <Typography variant="caption" color="text.secondary" fontWeight={600}>
                {label}
              </Typography>
              <Typography variant="body2">{value}</Typography>
              <Divider sx={{ mt: 1 }} />
            </Box>
          ))}
          <Box>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              Permissions
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 0.5 }}>
              {role.permissions?.length ? (
                role.permissions.map((p) => <Chip key={p.id} label={p.name} size="small" />)
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No permissions assigned.
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      }
      footer={undefined}
    />
  );
};
